export class CalculateDatapool {
  poolIdentifier: string;

  constructor(poolIdentifier: string) {
    this.poolIdentifier = poolIdentifier;
  }
}
